import VideoSlideshowView from './VideoSlideshowView';

export default VideoSlideshowView;
